import * as StoreUtil from '../util/InClientStoreUtil';
import ExtensibilityContext from 'owa-service/lib/contract/ExtensibilityContext';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getExtensibilityContext } from 'owa-addins-store';
import { getSessionId } from 'owa-config';
import 'owa-addins-osfruntime';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'GetTelemetryInfoFromOutlook',
        (data: any, responseMethod: Function) => {
            const context = getExtensibilityContext() as ExtensibilityContext;
            const userConfig = getUserConfiguration();
            const mailboxOnline: boolean = !userConfig.SessionSettings.IsSPOnPrem;
            const consumerMailbox: boolean = isConsumer();
            const officeSku: string = mailboxOnline
                ? consumerMailbox
                    ? 'Consumer'
                    : 'Business'
                : 'OnPremise';
            const providerType: string = 'other';
            const clientBuildType: string = 'OWA_REACT';
            responseMethod(
                [
                    getSessionId() /*Client Session id */,
                    userConfig.SessionSettings.UserCulture /*Locale */,
                    '16.2130.0.9999' /*Client Version - hardcoded for now since OMEX does not understand the new versioning */,
                    StoreUtil.getExchangeVersion() /*Exchange Version */,
                    officeSku /* Consumer/Business */,
                    mailboxOnline /* Mailbox online? */,
                    consumerMailbox /*Is consumer? */,
                    context.MarketplaceUrl /*Marketplace URL */,
                    userConfig.SessionSettings
                        .ExternalDirectoryUserGuid /*External Directory User Guid */,
                    userConfig.SessionSettings.OrganizationDomain /*Domain */,
                    StoreUtil.getOwaGuid() /* Transaction ID (Unique guids every time) */,
                    providerType /* for gmail accounts send 'gmail', else send 'other' */,
                    clientBuildType /*OWA_REACT for OWA, MSI/C2R for OLK*/,
                    context.GenericInfo /*Generic Information from exchange to Omex, without any intervention of clients.
                                          currently used for passing AgeGroup property */,
                ],
                0
            );
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}
